import {
  RESET_WHATSAPP_CHAT,
  SET_WA_CHAT_CUSTOMERS,
  SET_WA_CURRENT_CUSTOMER,
  SET_WA_CHAT_PUSHER_CHANNEL,
  SET_WA_CUSTOMER_CHAT_HISTORY,
  SET_WA_CUSTOMER_CONVERSATION_IDS,
} from "../types";

const initialState = {
  customers: {},
  customer: {},
  chatHistoryObj: {},
  conversationIdsObj: {},
  pusherChannel: null,
};

const waChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WA_CHAT_CUSTOMERS:
      return {
        ...state,
        customers: action.payload,
      };
    case SET_WA_CURRENT_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };
    case SET_WA_CUSTOMER_CHAT_HISTORY:
      return {
        ...state,
        chatHistoryObj: action.payload,
      };
    case SET_WA_CUSTOMER_CONVERSATION_IDS:
      return {
        ...state,
        conversationIdsObj: action.payload,
      };
    case SET_WA_CHAT_PUSHER_CHANNEL:
      return {
        ...state,
        pusherChannel: action.payload,
      };
    case RESET_WHATSAPP_CHAT:
      return initialState;
    default:
      return state;
  }
};

export default waChatReducer;
